//
// Copyright (c) 2011-2019 by Curalate, Inc.
//

import { IScope } from 'angular';
import React from 'react';
import { ActionButton } from 'unison';

import makeAngularReactControllerWithScope, {
  applyScope,
} from '@react-bridge/angular-react-widget-with-scope';
import { TRACKING_ACTION, TRACKING_CATEGORY } from '@tracker/trackerModel';

import gaApi from 'app/initialization/ga/ga-api';

interface Props {
  isDisabled: boolean;
  onClick: () => void;
  trackingAction: TRACKING_ACTION;
  trackingCategory: TRACKING_CATEGORY;
}

const UniversalImageActionsUndoBeautifyButton = ({
  isDisabled,
  onClick,
  trackingAction,
  trackingCategory,
}: Props) => {
  const handleUndoClick = () => {
    gaApi.recordEvent(trackingCategory, trackingAction);

    onClick();
  };

  return (
    <ActionButton
      data-testid='undo-beautify-button'
      iconName='undo'
      isDisabled={isDisabled}
      label='Undo Beautify'
      onClick={handleUndoClick}
    />
  );
};

angular
  .module('curalate')
  .component('universalImageActionsUndoBeautifyButton', {
    bindings: {
      isDisabled: '<',
      onClick: '&',
      trackingAction: '@',
      trackingCategory: '@',
    },
    controller: makeAngularReactControllerWithScope(
      (scope: { $ctrl: Props } & IScope) => {
        return (
          <div>
            <UniversalImageActionsUndoBeautifyButton
              isDisabled={scope.$ctrl.isDisabled}
              onClick={applyScope(scope, scope.$ctrl.onClick)}
              trackingAction={scope.$ctrl.trackingAction}
              trackingCategory={scope.$ctrl.trackingCategory}
            />
          </div>
        );
      },
    ),
  });
